import React, { FC } from 'react';

import { Button } from '@chakra-ui/react';

import { CopyAsCsvViewProps } from './CopyAsCsv.props';
import CopyIcon from 'svg/CopySvg';

const CopyAsCsvView: FC<CopyAsCsvViewProps> = ({
  copyToClipboard,
  title,
  showIcon = false,
}) => {
  return (
    <>
      {!showIcon ? (
        <Button onClick={copyToClipboard}>{title}</Button>
      ) : (
        <div onClick={copyToClipboard}>
          <CopyIcon />
        </div>
      )}
    </>
  );
};

export default CopyAsCsvView;
